var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-card-with-icon',{attrs:{"text":"שמתי בצד לתוכניות הגדולות","action":_vm.openPlanAheadModal,"out-of-date":_vm.outOfDate,"icon-name":"tour","additional-icon-props":_vm.iconProps}})}
var staticRenderFns = []

export { render, staticRenderFns }